<template>
  <div>
    <section>
      <template>
        <v-container fluid>
          <v-row class="match-height">
            <v-col cols="12">
              <v-data-table
                :items="dutyAttendances"
                :headers="attendanceTableHeaders"
                item-key="meta.id"
                dense
                :footer-props="footerProps"
                :mobile-breakpoint="0"
                no-data-text="Keine Anwesenheitseinträge in Dienstberichten vorhanden"
                class="elevation-2"
                :loading="dutyAttendancesQuery.isLoading"
              >
                <template v-slot:top>
                  <v-card flat>
                    <v-card-title class="body-2 v-card__subtitle mb-3"
                      ><v-icon left small class="mr-2"
                        >mdi-briefcase-edit</v-icon
                      >Anwesenheitseinträge in Dienstberichten
                    </v-card-title>
                    <v-card-subtitle>
                      <v-row :dense="$vuetify.breakpoint.smAndDown">
                        <v-col cols="5" sm="5" md="3">
                          <v-text-field
                            v-model="dutyAttendancesQuery.range.start"
                            type="date"
                            label="Startdatum"
                            hint="DD.MM.YYYY"
                            outlined
                            dense
                            :disabled="dutyAttendancesQuery.isLoading"
                            clearable
                            prepend-inner-icon="mdi-calendar-start"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5" sm="5" md="3">
                          <v-text-field
                            v-model="dutyAttendancesQuery.range.end"
                            type="date"
                            label="Enddatum"
                            hint="DD.MM.YYYY"
                            outlined
                            dense
                            :rules="[rules.required]"
                            required
                            :disabled="dutyAttendancesQuery.isLoading"
                            prepend-inner-icon="mdi-calendar-end"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn
                            depressed
                            color="success"
                            @click="getDutyAttendances()"
                            :disabled="dutyAttendancesQuery.range.end === null"
                            :loading="dutyAttendancesQuery.isLoading"
                            ><v-icon left small>mdi-magnify</v-icon>Abfrage
                            starten</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-subtitle>
                  </v-card>
                  <v-divider></v-divider>
                </template>
                <template v-slot:[`item.dutyReport.type.title`]="{ item }">
                  <duty-type-chip :dutyType="item.dutyReport.type" small>
                  </duty-type-chip>
                </template>
                <template v-slot:[`item.duration.start.timestamp`]="{ item }">
                  {{ timestampConverter(item.duration.start.timestamp) }}
                </template>
                <template v-slot:[`item.duration.end.timestamp`]="{ item }">
                  {{ timestampConverter(item.duration.end.timestamp) }}
                </template>
                <template
                  v-slot:[`item.assignedPosition.unit.title`]="{ item }"
                >
                  {{ item.assignedPosition.unit.title }} –
                  {{ item.assignedPosition.position.shortTitle }}
                </template>
                <template v-slot:[`item.note`]="{ item }">
                  <v-chip v-if="item.isWaiver" small label outlined
                    >Verzicht</v-chip
                  >{{ item.note }}
                </template>
                <template v-slot:[`item.actions`]="{ item }"
                  ><v-btn
                    v-if="showActionBtn"
                    depressed
                    @click="openDutyReport(item, 'newTab')"
                    small
                    ><v-icon left small>mdi-open-in-app</v-icon>Öffnen</v-btn
                  >
                  <v-menu v-else offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon text v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item link @click="routeDetails(item)">
                        <v-list-item-icon>
                          <v-icon dense>mdi-open-in-app</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Bericht öffnen</v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item link @click="openDutyReport(item, 'newTab')">
                        <v-list-item-icon>
                          <v-icon dense>mdi-open-in-new</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          >Bericht öffnen (in neuem Tab)</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" md="8">
              <events-data-table
                :events="events"
                hideResponsesSummary
                dense
                :loading="eventsQuery.isLoading"
              >
                <template v-slot:header>
                  <v-card flat>
                    <v-card-title class="body-2 v-card__subtitle mb-3"
                      ><v-icon left small class="mr-2"
                        >mdi-calendar-question</v-icon
                      >Veranstaltungsrückmeldungen
                    </v-card-title>
                    <v-card-subtitle>
                      <v-row :dense="$vuetify.breakpoint.smAndDown">
                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            v-model="eventsQuery.range.start"
                            type="date"
                            label="Startdatum"
                            hint="DD.MM.YYYY"
                            outlined
                            dense
                            :loading="eventsQuery.isLoading"
                            clearable
                            prepend-inner-icon="mdi-calendar-start"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            v-model="eventsQuery.range.end"
                            type="date"
                            label="Enddatum"
                            hint="DD.MM.YYYY"
                            outlined
                            dense
                            :rules="[rules.required]"
                            required
                            :loading="eventsQuery.isLoading"
                            prepend-inner-icon="mdi-calendar-end"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn
                            depressed
                            color="success"
                            :loading="eventsQuery.isLoading"
                            :disabled="eventsQuery.range.end === null"
                            @click="getEvents()"
                            ><v-icon left small>mdi-magnify</v-icon>Abfrage
                            starten</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-subtitle>
                  </v-card>
                  <v-divider></v-divider>
                </template>
              </events-data-table>
            </v-col>
            <v-col cols="12" md="4">
              <v-card :loading="eventsQuery.isLoading">
                <v-card-title class="body-2 v-card__subtitle mb-3"
                  ><v-icon left small class="mr-2">mdi-chart-donut</v-icon>
                  Rückmeldungen zu Veranstaltungen im ausgewählten Zeitraum
                </v-card-title>
                <v-card-text>
                  <v-row v-if="!eventsQuery.isCompleted">
                    <v-col cols="12">
                      <v-card
                        outlined
                        class="lighten-4 text-center d-flex align-center justify-center"
                        flat
                        ><v-card-text>
                          <div>
                            <v-icon class="mb-2"> mdi-alert-circle</v-icon>
                            <p>Keine Zusammenfassung verfügbar</p>
                          </div>
                        </v-card-text></v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12">
                      <v-row dense>
                        <v-col cols="12">
                          <v-card color="green lighten-4" dark outlined>
                            <v-card-title class="py-1">
                              <div
                                class="font-weight-medium subtitle-2 text--darken-4 green--text"
                              >
                                <v-icon
                                  left
                                  small
                                  class="text--darken-4 green--text"
                                  >mdi-check</v-icon
                                >Verfügbar
                              </div>
                              <v-spacer></v-spacer>
                              <div
                                class="font-weight-medium text-h5 text--darken-4 green--text"
                              >
                                {{ rsvpStats.totalConfirmations }}
                              </div>
                            </v-card-title>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card color="orange lighten-4" dark outlined>
                            <v-card-title class="py-1">
                              <div
                                class="font-weight-medium subtitle-2 text--darken-4 orange--text"
                              >
                                <v-icon
                                  left
                                  small
                                  class="text--darken-4 orange--text"
                                  >mdi-minus</v-icon
                                >
                                Wenn notwendig
                              </div>
                              <v-spacer></v-spacer>
                              <div
                                class="font-weight-medium text-h5 text--darken-4 orange--text"
                              >
                                {{ rsvpStats.totalIfNecessary }}
                              </div>
                            </v-card-title>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card color="red lighten-4" dark outlined>
                            <v-card-title class="py-1">
                              <div
                                class="font-weight-medium subtitle-2 text--darken-4 red--text"
                              >
                                <v-icon
                                  left
                                  small
                                  class="text--darken-4 red--text"
                                  >mdi-close</v-icon
                                >
                                Nicht verfügbar
                              </div>
                              <v-spacer></v-spacer>
                              <div
                                class="font-weight-medium text-h5 text--darken-4 red--text"
                              >
                                {{ rsvpStats.totalCancellations }}
                              </div>
                            </v-card-title>
                            <v-card-subtitle
                              class="pt-3 pb-2 text--darken-4 red--text"
                            >
                              (davon
                              {{ rsvpStats.totalCancellationNotices }}
                              kurzfristige Abmeldungen)
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card color="blue lighten-4" dark outlined>
                            <v-card-title class="py-1">
                              <div
                                class="font-weight-medium subtitle-2 text--darken-4 blue--text"
                              >
                                <v-icon
                                  left
                                  small
                                  class="text--darken-4 blue--text"
                                  >mdi-airplane</v-icon
                                >
                                Nicht in Stadt
                              </div>
                              <v-spacer></v-spacer>
                              <div
                                class="font-weight-medium text-h5 text--darken-4 blue--text"
                              >
                                {{ rsvpStats.totalNotInTown }}
                              </div>
                            </v-card-title>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card color="brown lighten-4" dark outlined>
                            <v-card-title class="py-1">
                              <div
                                class="font-weight-medium subtitle-2 text--darken-4 brown--text"
                              >
                                <v-icon
                                  left
                                  small
                                  class="text--darken-4 brown--text"
                                  >mdi-help</v-icon
                                >
                                Ohne Rückmeldung
                              </div>
                              <v-spacer></v-spacer>
                              <div
                                class="font-weight-medium text-h5 text--darken-4 brown--text"
                              >
                                {{ rsvpStats.totalAwaitingResponse }}
                              </div>
                            </v-card-title>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" hidden>
                      <v-card
                        height="180px"
                        class="text-center d-flex align-center justify-center"
                        outlined
                      >
                        <v-card-text>
                          <VueApexCharts
                            type="donut"
                            height="160"
                            :options="chartOptions"
                            :series="chartSeries"
                          />
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import { db, Timestamp } from "@/firebase";
import EventsDataTable from "@/components/scheduling/EventsDataTable.vue";
import DutyTypeChip from "@/components/duty-management/DutyTypeChip.vue";
import VueApexCharts from "vue-apexcharts";
export default {
  name: "member-management-personnel-records-details-attendances",
  components: {
    EventsDataTable,
    DutyTypeChip,
    VueApexCharts,
  },
  data() {
    return {
      footerProps: {
        "items-per-page-options": [15, 25, 50, 100, -1],
      },
      eventsQuery: {
        range: {
          start: null,
          end: null,
        },
        isCompleted: false,
        isLoading: false,
      },
      dutyAttendancesQuery: {
        range: {
          start: null,
          end: null,
        },
        isCompleted: false,
        isLoading: false,
      },
      loading: false,
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
      attendanceTableHeaders: [
        { text: "Titel", value: "dutyReport.title", divider: true },
        { text: "Dienstart", value: "dutyReport.type.title", divider: true },
        {
          text: "Startzeitpunkt",
          value: "duration.start.timestamp",
          divider: true,
        },
        {
          text: "Endzeitpunkt",
          value: "duration.end.timestamp",
          divider: true,
        },
        {
          text: "Einheit",
          value: "assignedPosition.unit.title",
          divider: true,
        },
        // { text: "Status", value: "attendanceStatus" },
        { text: "Notiz", value: "note", divider: true },
        {
          value: "actions",
          sortable: false,
        },
      ],
      dutyAttendances: [],
      events: [],
      rsvpStats: {
        totalEvents: 0,
        totalConfirmations: 0,
        totalCancellations: 0,
        totalCancellationNotices: 0,
        totalIfNecessary: 0,
        totalNotInTown: 0,
        totalAwaitingResponse: 0,
      },
      chartOptions: {
        chart: {
          type: "donut",
        },
        legend: { show: false },
        labels: [
          "Verfügbar",
          "Wenn notwendig",
          "Nicht verfügbar",
          "Nicht in Stadt",
          "Ohne Rückmeldung",
        ],
        colors: ["#c8e6c9", "#ffe0b2", "#ffcdd2", "#bbdefb", "#d7ccc8"],
        dataLabels: {
          // style: {
          //   colors: ["#1b5e20", "#e65100", "#b71c1c", "#0d47a1", "#3e2723"],
          // },
        },
        stroke: { width: 0 },
      },
      chartSeries: [],
    };
  },
  computed: {
    checkIfSupport() {
      return this.$store.state.supportTools;
    },
    code() {
      return this.$store.state.code;
    },
  },
  created() {
    console.log(this.personnelRecord.memberSince);
    this.dutyAttendancesQuery.range.start = this.personnelRecord.memberSince;
    this.eventsQuery.range.start = this.personnelRecord.memberSince;
  },
  methods: {
    routeDetails(item) {
      if (!this.showActionBtn) {
        this.openDutyReport(item);
      }
    },
    openDutyReport(item, type = "default") {
      if (type === "newTab") {
        window.open(
          this.$router.resolve({
            name: "duty-management-reports-details",
            params: {
              organizationId: this.$route.params.organizationId,
              itemId: item.dutyReportId,
            },
          }).href,
          "_blank"
        );
        return;
      } else {
        this.$router.push({
          name: "duty-management-reports-details",
          params: {
            organizationId: this.$route.params.organizationId,
            itemId: item.dutyReportId,
          },
        });
      }
    },
    getDutyAttendances() {
      this.dutyAttendancesQuery.isLoading = true;
      this.dutyAttendancesQuery.isCompleted = false;
      this.dutyAttendances = [];

      const queryStart = Timestamp.fromMillis(
        new Date(this.dutyAttendancesQuery.range.start)
      );
      const queryEnd = Timestamp.fromMillis(
        new Date(this.dutyAttendancesQuery.range.end)
      );
      db.collectionGroup("dutyAttendances")
        .where("organizationId", "==", this.$route.params.organizationId)
        .where("attendanceStatus", "==", "1")
        .where("user.uid", "==", this.$route.params.itemId)
        .where("dutyReport.status", "in", [
          "approved",
          "toBeReviewed",
          "completed",
        ])
        .where("duration.start.timestamp", ">=", queryStart)
        .where("duration.start.timestamp", "<=", queryEnd)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.dutyAttendances.push(doc.data());
          });

          this.dutyAttendancesQuery.isCompleted = true;
          this.dutyAttendancesQuery.isLoading = false;
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    getEvents() {
      this.eventsQuery.isLoading = true;
      this.eventsQuery.isCompleted = false;
      this.events = [];

      const queryStart = Timestamp.fromMillis(
        new Date(this.eventsQuery.range.start)
      );
      const queryEnd = Timestamp.fromMillis(
        new Date(this.eventsQuery.range.end)
      );

      var ownUserGroup = "payload.query.ownUserGroup";
      var ownDivision = "rootState.organization.membership.user.division.id";
      var ownUid = this.$route.params.itemId;

      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("events")
        .where("duration.start.timestamp", ">=", queryStart)
        .where("duration.start.timestamp", "<=", queryEnd)
        .where("config.attendance.allowedAttendeesIds", "array-contains-any", [
          "all",
          ownUid,
          ownUserGroup,
          ownDivision,
        ])
        .orderBy("duration.start.timestamp", "asc")
        .get()
        .then((querySnapshot) => {
          const eventPromises = [];
          var options = {
            weekday: "short",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          };
          querySnapshot.forEach((doc) => {
            const eventDoc = {
              ...doc.data(),
              duration: {
                start: {
                  firebaseFormat: doc.data().duration.start.timestamp,
                  dateFormat: doc.data().duration.start.timestamp.toDate(),
                  timestamp: doc
                    .data()
                    .duration.start.timestamp.toDate()
                    .toLocaleString("de-DE", options),
                  isOpen: doc.data().duration.start.isOpen,
                },
                end: {
                  firebaseFormat: doc.data().duration.end.timestamp,
                  timestamp: doc
                    .data()
                    .duration.end.timestamp.toDate()
                    .toLocaleString("de-DE", options),
                  isOpen: doc.data().duration.end.isOpen,
                },
              },
            };
            const responsePromise = db
              .collection("organizations")
              .doc(this.$route.params.organizationId)
              .collection("events")
              .doc(doc.id)
              .collection("responses")
              .doc(ownUid)
              .get()
              .then((responseDoc) => {
                if (responseDoc.exists) {
                  eventDoc.userResponse = responseDoc.data();
                } else {
                  eventDoc.userResponse = {
                    status: { id: "0" },
                    isCanceled: false,
                  };
                }
                return eventDoc;
              });
            eventPromises.push(responsePromise);
          });

          Promise.all(eventPromises)
            .then((eventsWithResponses) => {
              this.events = eventsWithResponses;
              this.rsvpStats = {
                totalEvents: eventsWithResponses.length,
                totalConfirmations: 0,
                totalCancellations: 0,
                totalCancellationNotices: 0,
                totalIfNecessary: 0,
                totalNotInTown: 0,
                totalAwaitingResponse: 0,
              };

              eventsWithResponses.forEach((event) => {
                const response = event.userResponse;
                if (response) {
                  switch (response.status.id) {
                    case "1":
                      this.rsvpStats.totalConfirmations++;
                      break;
                    case "2":
                      this.rsvpStats.totalCancellations++;
                      if (response.isCanceled) {
                        this.rsvpStats.totalCancellationNotices++;
                      }
                      break;
                    case "3":
                      this.rsvpStats.totalIfNecessary++;
                      break;
                    case "4":
                      this.rsvpStats.totalNotInTown++;
                      break;
                    case "0":
                      this.rsvpStats.totalAwaitingResponse++;
                      break;
                  }
                }
              });

              // Update chartSeries for the donut chart
              this.chartSeries = [
                this.rsvpStats.totalConfirmations,
                this.rsvpStats.totalCancellations,
                this.rsvpStats.totalIfNecessary,
                this.rsvpStats.totalNotInTown,
                this.rsvpStats.totalAwaitingResponse,
              ];

              this.eventsQuery.isCompleted = true;
              this.eventsQuery.isLoading = false;
            })
            .catch((error) => {
              console.log("Error processing events with responses:", error);
            });
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>

<style></style>
